import React, { Component } from 'react';

//All of our API calls
import * as Actions from '../actions/action';

//Stores all of our API responses
import Store from '../stores/store';
import FileUpload from '../components/FileUpload.js';
import FileView from '../components/FileView.js';
import FileDelete from '../components/FileDelete.js';

//These are all our styles (font-awesome + our global css)
import '../styles/fonts/FontAwesome6/css/all.css';
import '../styles/global.css';

class AccessGroups extends Component {
    constructor(props) {
        super(props);
        const { user_AccountInfo } = props;

        Actions.getAccessGroups();

        var bodyList = [];

        this.state = {
            employeeList: [],
            employeeFilter: "",
            employeeSelected: "",
            employeeNotes: "",
            loadingEmployees: false,
            recentSearches: [],
            employeeAccessGroups: [],
            employeeValue: "",
            employeeFirstName: "",
            employeeLastName: "",
            allAccessGroups: [],
            accessGroupSelection: "",
            showAddError: false,
            showDeleteError: false,
            showUserManagement: true,
            showFileManagement: false,
        };
    }

    componentDidMount() {
        Store.on("Response_Employee_SearchList_Updated", this._updateEmployeeState.bind(this));
        Store.on("Response_Employee_AccessGroupList_Updated", this._updateEmployeeAccessGroups.bind(this));
        Store.on("Response_AccessGroupList_Updated", this._updateActionGroups.bind(this));
        Store.on("Response_Employee_AccessGroup_Added", this._checkAddError.bind(this));
        Store.on("Response_Employee_AccessGroup_Removed", this._checkDeleteError.bind(this));
    }

    componentWillUnmount() {
    }

    _checkAddError = () => {
        this.setState({ showAddError: Store.getAddEmployeeAccessGroupError() });
        Actions.getEmployeeAccessGroups(this.state.employeeValue);
    }

    _checkDeleteError = () => {
        this.setState({ showDeleteError: Store.getRemoveEmployeeAccessGroupError() });
        Actions.getEmployeeAccessGroups(this.state.employeeValue);
    }

    _updateActionGroups = () => {
        this.setState({ allAccessGroups: Store.getAccessGroups() });
        if (this.state.employeeValue !== "") {
            Actions.getEmployeeAccessGroups(this.state.employeeValue);
        }
    }

    _handleDynamicNameChange = () => {
        var inputFilter = this.refs['employeeFilterName_Input'].value;

        this.setState({
            employeeFilter: inputFilter,
            loadingEmployees: true,
            employeeList: [],
            employeeSelected: "",
            employeeAccessGroups: [],
            employeeValue: "",
            employeeFirstName: "",
            employeeLastName: ""
        })
        if (inputFilter.length < 3) {
            return;
        }
        else {
            if (inputFilter.indexOf('@') > -1) {
                inputFilter = inputFilter.substring(0, inputFilter.indexOf('@'));
                Actions.getEmployeeSearchList(inputFilter);
            }
            else {
                Actions.getEmployeeSearchList(inputFilter);
            }
        }

    }

    _addSearchToRecentList = () => {
        var inputFilter = this.refs['employeeFilterName_Input'].value;
        var recentArray = this.state.recentSearches;
        if (inputFilter.length > 3) {
            if (recentArray.indexOf(inputFilter) === -1) {
                recentArray.push(inputFilter);
            }

            this.setState({
                recentSearches: recentArray
            })
        }
    }

    _updateEmployeeAccessGroups = () => {
        this.setState({ employeeAccessGroups: [...Store.getEmployeeAccessGroups()] });
    }

    _updateSearch(searchValue) {
        this.refs['employeeFilterName_Input'].value = searchValue;
        this.setState({
            employeeFilter: searchValue,
        });
        this._handleDynamicNameChange();
    }

    _updateEmployeeState = () => {

        var filteredEmployeesList = Store.getEmployeeSearchList();

        filteredEmployeesList = [
            ...new Map(filteredEmployeesList.map((item) => [item["employeeNumber"], item])).values(),
        ];

        this.setState({
            employeeList: filteredEmployeesList,
        })
        this.setState({
            loadingEmployees: false,
        });
    }

    _triggerSearchChange = () => {
        let that = this;
        let other = this;
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(function () {
            that._handleDynamicNameChange()
        }, 300);

        clearTimeout(this.recentTimer);
        this.recentTimer = setTimeout(function () {
            other._addSearchToRecentList()
        }, 1000);
    }

    _employeeChange = (event) => {
        this.setState({ employeeValue: event.target.value });
        var selectedOption = event.target.options[event.target.selectedIndex];
        var firstName = selectedOption.dataset.firstname;
        var lastName = selectedOption.dataset.lastname;
        this.setState({ employeeFirstName: firstName });
        this.setState({ employeeLastName: lastName });

        Actions.getEmployeeAccessGroups(event.target.value);
    }

    _handleAccessGroupChange = (event) => {
        this.setState({ accessGroupSelection: event.target.value });
    }

    _handleAdd(accessGroupId) {
        Actions.addEmployeeAccessGroup(accessGroupId, this.state.employeeValue);
        this.setState({ accessGroupSelection: '' });
    }

    _handleDelete(accessGroupId) {
        Actions.removeEmployeeAccessGroup(accessGroupId, this.state.employeeValue);
        this.setState({ accessGroupSelection: '' });
    }

    _showFileManagement() {
        Actions.getAccessGroups();
        this.setState({
            showFileManagement: true,
            showUserManagement: false
        })
    }

    _showUserManagement() {
        this.setState({
            employeeFilter: "",
            loadingEmployees: true,
            employeeList: [],
            showFileManagement: false,
            showUserManagement: true,
            employeeSelected: "",
            employeeAccessGroups: [],
            employeeValue: "",
            employeeFirstName: "",
            employeeLastName: ""
        })
    }

    render() {
        var bodyList = [];
        var employeeManagement = [];
        var employeeAccess = [];

        var userManagement = [];
        var fileManagement = [];

        var userManagementButtonClass = "";
        var fileManagementButtonClass = "";

        var employeeList = [];

        var bodyContent = [];

        var addInstancePlaceholder = [];

        var accessCompleteList = [];

        var filteredEmployees;
        filteredEmployees = [];

        var selectedEmployeeName = [];

        var filteredEmployeesList = this.state.employeeList;

        var allAccessGroups = this.state.allAccessGroups;

        var filteredEmployeeCount = 0;
        var filteredEmployeeCountContainer;
        filteredEmployeeCountContainer = [];
        if (this.state.employeeFilter.length >= 3 && !this.state.loadingEmployees && Object.keys(filteredEmployeesList).length > 0) {
            filteredEmployeeCount = Object.keys(filteredEmployeesList).length;
            filteredEmployeeCountContainer.push(
                <span className="filteredEmployeeCount">( {filteredEmployeeCount} )</span>
            )
        }
        else if (this.state.employeeFilter.length >= 3 && this.state.loadingEmployees) {
            filteredEmployeeCountContainer.push(
                <span className="filteredEmployeeCount">( <i className="loginSpinnerUpper fa-light fa-spinner-third fa-spin"></i> )</span>
            )
        }


        if (this.state.employeeFilter.length >= 3 && !this.state.loadingEmployees && Object.keys(this.state.employeeList).length > 0) {

            Object.values(filteredEmployeesList).forEach(element => {
                filteredEmployees.push(<option ref={element["employeeNumber"]} key={element["employeeNumber"]} value={element["employeeNumber"]} data-firstname={element["firstName"]} data-lastname={element["lastName"]}>{element["lastName"]}, {element["firstName"]} ({element["email"]})</option>)
            });
            
      
            employeeList.push(
                <select size="7" ref="employee_List" className="employee_List" value={this.state.employeeValue} onChange={this._employeeChange}>
                    {filteredEmployees}
                </select>
            )
        }
        else if (this.state.employeeFilter.length >= 3 && this.state.loadingEmployees) {
            employeeList.push(
                <select size="7" ref="employee_List" className="employee_List hidden">
                </select>
            )
            employeeList.push(
                <div className="employee_ListPlaceholder">
                    <div className="employee_ListPlaceholder_NoResults"><i className="loginSpinnerUpper fa-light fa-spinner-third fa-spin"></i></div>
                </div>
            )
        }
        else if (this.state.employeeFilter.length >= 3 && !this.state.loadingEmployees && Object.keys(this.state.employeeList).length === 0) {
            employeeList.push(
                <select size="7" ref="employee_List" className="employee_List hidden">
                </select>
            )
            employeeList.push(
                <div className="employee_ListPlaceholder">
                    <div className="employee_ListPlaceholder_NoResults">No results found for: <span className="noResults_FilterText">{this.state.employeeFilter}</span></div>
                </div>
            )
        }
        else if (this.state.employeeFilter.length < 3 && this.state.recentSearches.length > 0) {
            employeeList.push(
                <select size="7" ref="employee_List" className="employee_List hidden">
                </select>
            )
            var linkRecentSearches;
            linkRecentSearches = [];
            Object.values(this.state.recentSearches)
                .forEach(value => {
                    linkRecentSearches.push(<div className="recentSearches" onClick={this._updateSearch.bind(this, value)}>{value}</div>)
                });
            employeeList.push(
                <div className="employee_ListPlaceholder">
                    <div className="employee_ListPlaceholder_NoResults">Recent Searches: {linkRecentSearches}</div>
                </div>
            )
        }
        else {
            employeeList.push(
                <select size="7" ref="employee_List" className="employee_List hidden">
                </select>
            )
            employeeList.push(
                <div className="employee_ListPlaceholder">
                    <div className="employee_ListPlaceholder_Text">Enter atleast three characters in the filter above to begin your employee search.</div>
                </div>
            )
        }

        addInstancePlaceholder.push(
            <div className="instanceData">
                <div className="employee_Instance">
                    <table className="employeeList_Header">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="employeeList_Label_Container">
                                        <span className="employeeList_Label"><i className="employeeList_icon fal fa-user-md"></i> Employees {filteredEmployeeCountContainer}</span>
                                    </div>
                                </td>
                                <td className="employeeFilters">
                                    <div className="employeeFilterName_Container">
                                        <span className="employeeFilterName">
                                            <i className="filterList_icon fal fa-search"></i> Name
                                        </span>
                                        <input className="employeeFilterName_Input" ref="employeeFilterName_Input" type="text" placeholder="Last Name, First Name (Email)" defaultValue={this.state.employeeFilter} onChange={this._triggerSearchChange.bind(this)} />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {
                        employeeList
                    }
                </div>
            </div>
        );
        employeeManagement.push(addInstancePlaceholder);
        selectedEmployeeName = <div className="noEmployeeList_Label_Container"><span className="employeeList_Label"><i className="employeeList_icon fal fa-user-md"></i>Individual User Access</span></div>;

        if (this.state.employeeFirstName.length > 0) {
            
            selectedEmployeeName = <div className="employeeList_Label_Container"><span className="employeeList_Label"><i className="employeeList_icon fal fa-user-md"></i>{this.state.employeeFirstName + " " + this.state.employeeLastName}</span></div>;
        }

        employeeAccess.push(
            <table className="employeeList_Header">
                <tbody>
                    <tr>
                        <td>
                            {selectedEmployeeName}
                        </td>
                    </tr>
                </tbody>
            </table>
        )

        if (this.state.employeeFirstName.length > 0 && allAccessGroups.length > 0) {
            Object.values(this.state.allAccessGroups).forEach(accessGroup => {
                const employeeAccessGroup = Object.values(this.state.employeeAccessGroups).find(employeeAccessGroup => employeeAccessGroup.accessGroupId === accessGroup.accessGroupId);

                if (this.state.employeeFirstName.length > 0) {
                    if (employeeAccessGroup) {
                        // Access group exists in both states
                        accessCompleteList.push(
                            <div className="accessGroupButtonContainer removeAccessButton" value={accessGroup.accessGroupId} onClick={this._handleDelete.bind(this, accessGroup.accessGroupId)}>
                                {accessGroup.accessGroupName}
                                <i className="accessGroupRemoveIcon fal fa-minus"></i>
                            </div>
                        );
                    } else {
                        // Access group only exists in allAccessGroups state
                        accessCompleteList.push(
                            <div className="accessGroupButtonContainer addAccessButton" value={accessGroup.accessGroupId} onClick={this._handleAdd.bind(this, accessGroup.accessGroupId)}>
                                {accessGroup.accessGroupName}
                                <i className="accessGroupAddIcon fal fa-plus"></i>
                            </div>
                        );
                    }
                }
            });
            employeeAccess.push(<div className="accessGroupButtonList">{accessCompleteList}</div>)
        }
        else {
            employeeAccess.push(<div>
                <div className="accessGroupButtonContainerNoUser">
                Please search / select an employee first.
                </div>
            </div>)
        }
        //use this state to list all allAccessGroups
        //user this state to list just this employee's access groups, this.state.employeeAccessGroups

        userManagementButtonClass = "userManagementButton managementButton singleButton";
        fileManagementButtonClass = "fileManagementButton managementButton";

        bodyContent.push(<div className="accessGroups_selectOption">
            Please select a option above.
        </div>)

        if (this.state.showUserManagement) {
            userManagement.push(
                <div>
                    <div className="userManagementHeader"><span className="userManagementIcon fal fa-user"></span><span className="userManagementText">User Management</span></div>
                    <table className="userManagementTable">
                        <tbody>
                            <tr>
                                <td className="employeeManagement_Section">
                                    {employeeManagement}
                                </td>
                                <td className="employeeAccess_Section">
                                    {employeeAccess}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
            userManagementButtonClass = "userManagementButton_Selected managementButton singleButton";
            fileManagementButtonClass = "fileManagementButton managementButton";
            bodyContent = [];
            bodyContent.push(
                userManagement
            );
        }
        else if (this.state.showFileManagement) {
            fileManagement.push(
                <div>
                    <div className="fileManagementHeader"><span className="fileManagementIcon fal fa-files"></span><span className="fileManagementText">File Management</span></div>
                    <table className="fileManagementTable">
                        <tbody>
                            <tr>
                                <td className="fileUpload_Section">
                                    <div className="fileManagementSubHeader"><span className="fileManagementSubIcon fa-light fa-cloud-arrow-up"></span><span className="fileManagementSubText">Upload</span></div>
                                    <FileUpload />
                                </td>
                                <td className="fileDownload_Section">
                                    <div className="fileManagementSubHeader"><span className="fileManagementSubIcon fa-light fa-display-arrow-down"></span><span className="fileManagementSubText">Download</span></div>
                                    <FileView />
                                </td>
                                <td className="fileDelete_Section">
                                    <div className="fileManagementSubHeader"><span className="fileManagementSubIcon fa-light fa-file-xmark"></span><span className="fileManagementSubText">Delete</span></div>
                                    <FileDelete />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
            userManagementButtonClass = "userManagementButton managementButton singleButton";
            fileManagementButtonClass = "fileManagementButton_Selected managementButton";
            bodyContent = [];
            bodyContent.push(
                fileManagement
            );
        }


        bodyList.push(
            <div className="popupOverlay">
                <div className="dynamicAdd_Container">
                    <div className="modalContent">
                        <div className="accessGroups_singleResource_Header">
                            <span className="addInstanceIcon fal fa-user-group"></span> Access Groups
                        </div>
                        <div className="accessGroups_contentContainer">
                            <div className="accessGroups_buttonContainer">
                                <div className="singleResultButtons">
                                    <button onClick={this._showUserManagement.bind(this)} className={userManagementButtonClass}><table><tbody><tr><td><span className="singleResultIcon fal fa-user"></span></td><td><span className="footerText"><div className="topText">User</div><div className="bottomText">Management</div></span></td></tr></tbody></table></button>
                                    <button onClick={this._showFileManagement.bind(this)} className={fileManagementButtonClass}><table><tbody><tr><td><span className="singleResultIcon fal fa-files"></span></td><td><span className="footerText"><div className="topText">File</div><div className="bottomText">Management</div></span></td></tr></tbody></table></button>
                                </div>
                            </div>
                            <div classname="accessGroups_bodyContent">
                                {bodyContent}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <div>
                <div>{bodyList}</div>
            </div>
            )
    }

}

AccessGroups.propTypes = {
}

export default AccessGroups